export const COUNTRY_WORKER_REQUEST_UNKNOWN = 'unknown';
export const COUNTRY_WORKER_REQUEST_GET_COUNTRY_CITIES = 'get_country_cities';
export const COUNTRY_WORKER_REQUEST_GET_ALL_COUNTRIES = 'get_all_countries';

export type CountryWorkerMessageType = {
  request: string;
  data?: any;
};
